import axios, { AxiosRequestConfig } from 'axios';
import { useCallback, useState } from 'react';

const useDownloadResource = (
  requestProps: AxiosRequestConfig = {
    method: 'post',
  },
) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<any | null>(null);

  const downloadResource = useCallback(
    async ({ url, payload, params }: { url: string; payload?: any; params?: any }) => {
      try {
        setError(null);
        setLoading(true);
        const { data: blobResponse } = await axios({
          url,
          data: payload,
          params,
          responseType: 'blob',
          ...requestProps,
        });
        setLoading(false);
        return blobResponse;
      } catch (e) {
        setError(e);
        setLoading(false);
        console.error('Error downloading the selected file', e);
        return null;
      }
    },
    [requestProps],
  );

  return {
    loading,
    downloadResource,
    error,
  };
};

export default useDownloadResource;
